var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('p-toolbar-action',{attrs:{"icon":"mdi-dog","tooltip":"Woff Woff!!"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }